import { FhsAxios } from "../../services/axios";
import moment from "moment";

export default {
  state: {
    cashList: null,
    cashData: {},
    cashDataSelectedIndex: 0,
    toDate: moment().format("DD.MM.YYYY")
  },
  actions: {
    fetchUserCash({ commit, getters }) {
      commit("unsetUserCash");

      let url = "user/cash";
      // console.log(getters.toDate);
      // console.log(this);
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      FhsAxios.post(url, {
        toDate: getters.toDate
      }).then(response => {
        // if (response.data.status) {
        commit("setUserCash", response.data.result);
        // }
      });
    },
    changeToDate({ commit, dispatch }, toDate) {
      // Показываем прелоадер
      commit("unsetUserCash");
      // Выставляем новый промежуток даты
      commit("setToDate", toDate);
      // Загружаем новые данные
      dispatch("fetchUserCash");
    }
  },
  mutations: {
    cashDataSetSelectedIndex: (state, payload) =>
      (state.cashDataSelectedIndex = payload),
    setUserCash(state, payload) {
      state.cashData = payload;
      state.cashList = payload.cash || null;
    },
    setToDate(state, toDate) {
      state.toDate = toDate;
    },
    unsetUserCash(state) {
      state.cashList = null;
    }
  },
  getters: {
    userCash(state) {
      return state.cashList;
    },
    toDate(state) {
      return state.toDate;
    },
    getCashTableData: (state, getters) => {
      let result = {
        types: {}
      };
      console.log(getters.getCashData);
      if (getters.getCashData.total) {
        Object.entries(getters.getCashData.total).forEach(
          (item, item_index) => {
            let cash_type = {
              selected: false,
              total: item[1] || null,
              list: getters.getCashData.cash.filter(
                cash => cash.ACCTYPE === item[0]
              )
            };
            if (item_index === state.cashDataSelectedIndex) {
              cash_type.selected = true;
              result["selected"] = cash_type;
            }
            result["types"][item[0]] = cash_type;
          }
        );
      }
      return result || {};
    },
    getCashData: state => state.cashData || null
  }
};
